var _title, _desc, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconPlus = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "plus (2)")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SBL-Product-page",
    transform: "translate(-1250.000000, -2093.000000)",
    fill: "#288090",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus-(2)",
    transform: "translate(1250.000000, 2093.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.828125,13.828125 L16.171875,13.828125 L16.171875,1.171875 C16.171875,0.524648438 15.6472266,0 15,0 C14.3527734,0 13.828125,0.524648438 13.828125,1.171875 L13.828125,13.828125 L1.171875,13.828125 C0.524648438,13.828125 0,14.3527734 0,15 C0,15.6472266 0.524648438,16.171875 1.171875,16.171875 L13.828125,16.171875 L13.828125,28.828125 C13.828125,29.4753516 14.3527734,30 15,30 C15.6472266,30 16.171875,29.4753516 16.171875,28.828125 L16.171875,16.171875 L28.828125,16.171875 C29.4753516,16.171875 30,15.6472266 30,15 C30,14.3527734 29.4753516,13.828125 28.828125,13.828125 Z",
    id: "Path"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPlus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_plus.a6c8104c.svg";
export { ForwardRef as ReactComponent };